var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 40 } },
    [
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 24, sm: 12, lg: 8 } },
        [
          _c(
            "div",
            { staticClass: "card-panel", staticStyle: { cursor: "default" } },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-people" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "peoples",
                      "class-name": "card-panel-icon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalNoOfUser >= 0
                ? _c(
                    "div",
                    { staticClass: "card-panel-description" },
                    [
                      _c("div", { staticClass: "card-panel-text" }, [
                        _vm._v(
                          "\n          Total Confirmed Participants\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("count-to", {
                        staticClass: "card-panel-num",
                        attrs: {
                          "start-val":
                            _vm.totalNoOfUser - 20 > 0
                              ? _vm.totalNoOfUser - 20
                              : 0,
                          "end-val": _vm.totalNoOfUser,
                          duration: 3000,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 24, sm: 12, lg: 8 } },
        [
          _c(
            "div",
            { staticClass: "card-panel", staticStyle: { cursor: "default" } },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-people-gray" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "peoples",
                      "class-name": "card-panel-icon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalNoOfUnconfirmUser >= 0
                ? _c(
                    "div",
                    { staticClass: "card-panel-description" },
                    [
                      _c("div", { staticClass: "card-panel-text" }, [
                        _vm._v("\n          Total Unconfirmed Users\n        "),
                      ]),
                      _vm._v(" "),
                      _c("count-to", {
                        staticClass: "card-panel-num",
                        attrs: {
                          "start-val":
                            _vm.totalNoOfUnconfirmUser - 20 > 0
                              ? _vm.totalNoOfUnconfirmUser - 20
                              : 0,
                          "end-val": _vm.totalNoOfUnconfirmUser,
                          duration: 3000,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 24, sm: 12, lg: 8 } },
        [
          _c(
            "div",
            { staticClass: "card-panel", staticStyle: { cursor: "default" } },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "education",
                      "class-name": "card-panel-icon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalNoOfILT >= 0
                ? _c(
                    "div",
                    { staticClass: "card-panel-description" },
                    [
                      _c("div", { staticClass: "card-panel-text" }, [
                        _vm._v("\n          Total Events\n        "),
                      ]),
                      _vm._v(" "),
                      _c("count-to", {
                        staticClass: "card-panel-num",
                        attrs: {
                          "start-val":
                            _vm.totalNoOfILT - 20 > 0
                              ? _vm.totalNoOfILT - 20
                              : 0,
                          "end-val": _vm.totalNoOfILT,
                          duration: 3000,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }